export interface Stages {
  studyDate?: string // Fecha Estudio
  office?: string // Completo en oficina,
  bank?: string // Radicado en banco
  success?: string // Exitoso
  feesOrPayments?: string // Honorarios / Abonos
  fee?: number // Honorarios
  payments?: number // Abonos
  received?: string // Recibido
  returned?: string // Devuelto
  rejected?: string // Rechazado
  delivered?: string // Entregado
  documented?: string // Documentado
  _id?: string
}

export enum Role {
  operaciones = 'operaciones',
  asesor = 'asesor',
  referenciador = 'referenciador',
  admin = 'admin',
  ejecutivo = 'ejecutivo',
  agente = 'agente',
  analista = 'analista',
  gestor = 'gestor',
  casos = 'casos',
  gerente = 'gerente',
  procesos = 'procesos'
}

export enum roleLabel {
  operaciones = 'Gestor Bancario CO',
  asesor = 'Asesor Comercial',
  referenciador = 'Club',
  admin = 'Administrador',
  ejecutivo = 'Ejecutivo Comercial',
  agente = 'Agente',
  analista = 'Analista',
  gestor = 'Gestor Bancario',
  casos = 'Casos',
  gerente = 'Gerente',
  procesos = 'Procesos'
}

export function getRoleEnum(role: string) {
  const normalizedRole = role === 'gestores' ? Role.gestor : role

  switch (role) {
    case Role.admin:
      return Role.admin
    case Role.operaciones:
      return Role.operaciones
    case Role.asesor:
      return Role.asesor
    case Role.ejecutivo:
      return Role.ejecutivo
    case Role.agente:
      return Role.agente
    case Role.analista:
      return Role.analista
    case Role.gestor:
      return Role.gestor
    case Role.casos:
      return Role.casos
    case Role.gerente:
      return Role.gerente
    case Role.procesos:
      return Role.procesos
    default:
      return normalizedRole === Role.gestor ? Role.gestor : Role.referenciador
  }
}

export interface Conversation {
  _id?: string
  authorName: string
  value: string
  date: string
  type: string
}
export interface User {
  _id?: string
  name: string
  phone: string
  city: string
  files: Doc[]
  document: string
  email: string
  role: Role
  isVerified: boolean
  parentName?: string
  stages?: Stages
  bank?: string
  bankDocument?: string
  income?: string
  comments?: string
  children?: []
  isSaver: boolean
  isRejected?: boolean
  isRecovered?: boolean
  createdAt?: string
  isCrm?: boolean
  executive?: {
    name?: string
    id?: string
  }
  parent?: User
  analyst?: any
  isReturned?: boolean
  isObservation?: boolean
  isTest?: boolean
  accountData?: {
    accountNumber?: number | string
    bankName?: string
    accountType?: string
    accountDocument?: string
    accountDocumentLink?: string
    physicalAddress?: string
    rutDocument?: string
  }
  commission?: {
    status?: string
    amount?: number
    percentage?: number
    promotionAmount?: number
    promotionPercentage?: number
  }
  prepayment?: {
    status?: string
    amount?: number
  }
  extraFields?: ExtraField[]
  conversation?: Conversation[]
  bankStages?: {
    juridicalStages?: {
      value: string
      index: number
    }[]
  }
}

export interface TrackingRows extends User {
  id?: string
  name: string
  city: string
  parentName: string
  phone: string
  bankName?: string
  progress?: number
  studyDate: string
  office: string
  bank: string
  bankDocument: string
  success: string
  received: string
  returned: string
  delivered: string
  rejected: string
  feesOrPayments: string
  files: Doc[]
  comments: string
  isRejected?: boolean
  isRecovered?: boolean
  createdAt: string
  fee: number
  payments: number
  companyDocs?: string
  creditNumber?: number
  newInstallments?: number
  observations?: string
  savedInstallments?: number
  savedTaxes?: number
  newTotalAmount?: number
  executive?: {
    name?: string
    id?: string
  }
}

export interface ExtraField {
  name: string
  value?: string | Date | null
  type: string
}

export interface Resource {
  _id?: string
  name: string
  link: string
  description?: string
}

export enum configurationTypes {
  boolean = 'boolean',
  string = 'string',
  array = 'array',
  number = 'number',
  object = 'object'
}
export interface Configuration {
  _id?: string
  name: string
  label: string
  value: any
  type: configurationTypes
  metadata: any
}
export interface Doc {
  _id?: string
  name?: string
  link?: string
}
